import { useAppSelector } from '@hooks/app/redux';
import { getLegacyProviderCode } from '@services/external/software-provider.api';
import { useQuery, UseQueryOptions } from 'react-query';

async function handler(providerId: string) {
  const { data } = await getLegacyProviderCode(providerId);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useLegacyProviderCode(options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(['softwareProvider:legacy', providerId], () => handler(providerId), options);
}

export default useLegacyProviderCode;
